import { NavLink } from 'react-router-dom';
import clsx from 'clsx';
import type { NavItem } from './Sidebar.types';

export const NavItems = ({
  item,
  isCollapsed,
  onClick,
}: {
  item: NavItem;
  isCollapsed: boolean;
  onClick?: () => void;
}) => {
  return (
    <NavLink
      to={item.path}
      end
      onClick={onClick}
      className={({ isActive }) =>
        clsx(
          'group relative flex items-center gap-3 rounded-lg px-3 py-2.5 transition-all duration-200',
          // On desktop when collapsed, center the icon
          isCollapsed && 'lg:justify-center',
          isActive
            ? 'bg-blue-600 text-white shadow-md shadow-blue-200'
            : 'text-gray-600 hover:bg-gray-100 hover:text-gray-900'
        )
      }
    >
      {({ isActive }) => (
        <>
          <item.icon
            className={clsx(
              'h-5 w-5 shrink-0',
              isActive ? 'text-white' : 'text-gray-500 group-hover:text-gray-700'
            )}
          />
          {/* Label: always show on mobile, hide on desktop when collapsed */}
          <span className={clsx('truncate font-medium', isCollapsed && 'lg:hidden')}>
            {item.label}
          </span>
          {/* Badge (expanded): always show on mobile, hide on desktop when collapsed */}
          {item.badge !== undefined && item.badge > 0 && (
            <span
              className={clsx(
                'ml-auto flex h-5 min-w-5 items-center justify-center rounded-full px-1.5 text-xs font-semibold',
                isActive ? 'bg-white text-blue-600' : 'bg-blue-100 text-blue-600',
                isCollapsed && 'lg:hidden'
              )}
            >
              {item.badge > 99 ? '99+' : item.badge}
            </span>
          )}
          {/* Badge (collapsed): only show on desktop when collapsed */}
          {item.badge !== undefined && item.badge > 0 && isCollapsed && (
            <span className='absolute -top-1 -right-1 hidden h-4 min-w-4 items-center justify-center rounded-full bg-red-500 px-1 text-xs font-semibold text-white lg:flex'>
              {item.badge > 99 ? '99+' : item.badge}
            </span>
          )}
        </>
      )}
    </NavLink>
  );
};
